import { PropsWithChildren } from 'react';
import { cx } from '#/Scripts/utilities/cx';
import Icon from '#sign-up/components/Icons/Icon';
import { SignupStep } from '#sign-up/components/SignUp/types';

export const SignUpStepIndicator = ({
  children,
  completed,
  step,
  currentStep,
  onStepChange,
}: PropsWithChildren<{
  completed: boolean;
  step: SignupStep;
  currentStep: SignupStep;
  onStepChange?: (step: SignupStep) => void;
}>) => {
  const isClickable = completed && !!onStepChange;

  return (
    <button
      className={cx('signup-step', completed && 'completed', step === currentStep && 'active')}
      onClick={() => completed && onStepChange?.(step)}
      style={isClickable ? undefined : { cursor: 'default' }}
      type="button"
    >
      <div className="signup-step-line" />
      <div className="signup-step-circle">
        <div className="signup-step-inner-circle">{completed ? <Icon>check</Icon> : step}</div>
      </div>
      <div className="signup-step-name">{children}</div>
    </button>
  );
};
